// TermsOfService.jsx
import React from "react";

const TermsOfService = () => {
  const lastUpdated = "August 12, 2025";

  return (
    <main className="min-h-screen bg-white text-gray-900 py-16 px-4 md:px-12 lg:px-24">
      <section className="max-w-7xl mx-auto">
        <header className="mb-8">
          <h1 className="capitalize md:text-[45px] text-[33px]  font-bold mb-2">Terms of Service</h1>
          <p className="text-sm text-gray-500">Last updated: {lastUpdated}</p>
        </header>

        <article className="prose prose-lg">
          <p className="text-[18px] text-gray-500">
            These Terms of Service (“Terms”) govern your use of the website <strong>townbell.in</strong> (the “Site”)
            and any services provided by Town Bell (“we”, “us”, or “our”). By accessing or using the Site, you agree to
            be bound by these Terms.
          </p>

                   <h4 className="text-[22px] font-bold text-black mt-6">

            1. Use of the Site</h4>
           <p className="text-[18px] text-gray-500">
            The Site and its content are provided for informational and marketing purposes related to Town Bell’s
            properties and services. You agree to use the Site only for lawful purposes and in compliance with these
            Terms.
          </p>

                  <h4 className="text-[22px] font-bold text-black mt-6">
        
            2. Account &amp; Contact</h4>
            <p className="text-[18px] text-gray-500">
            Certain features may require you to submit contact details or create an account. You agree to provide
            accurate information and keep it up-to-date. You are responsible for activities performed using your
            account or contact information.
          </p>

          <h4 className="text-[22px] font-bold text-black mt-6">
         
            3. Intellectual Property</h4>
           <p className="text-[18px] text-gray-500">
            All content on the Site — including text, images, logos, and design — is our property or used with
            permission. You may not copy, reproduce, or use our content for commercial purposes without our prior
            written consent.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">4. User Content</h4>
           <p className="text-[18px] text-gray-500">
            If you submit content (e.g., inquiries, reviews, images), you grant us a non-exclusive, royalty-free,
            worldwide license to use, reproduce, modify, and display that content in connection with the Site and our
            business.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">5. Disclaimers</h4>
            <p className="text-[18px] text-gray-500">
            The Site is provided “as is” and “as available.” We do not guarantee accuracy, completeness, or
            suitability of information. We disclaim all warranties to the fullest extent permitted by law.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">6. Limitation of Liability</h4>
        <p className="text-[18px] text-gray-500">
            To the maximum extent permitted by law, Town Bell and its affiliates will not be liable for any indirect,
            incidental, consequential, special, or punitive damages arising from your use of the Site.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">7. External Links</h4>
        <p className="text-[18px] text-gray-500">
            The Site may include links to third-party sites. We do not endorse and are not responsible for the content
            or practices of third-party websites.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">8. Privacy</h4>
        <p className="text-[18px] text-gray-500">
            Our Privacy Policy (available at <a href="/privacy-policy">/privacy-policy</a>) explains how we collect
            and use personal data. By using the Site you agree to the collection and use described in that policy.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">9. Governing Law</h4>
        <p className="text-[18px] text-gray-500">
            These Terms are governed by the laws of the jurisdiction where Town Bell is established. Any disputes will
            be subject to the exclusive jurisdiction of the courts in that jurisdiction.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">10. Changes to Terms</h4>
        <p className="text-[18px] text-gray-500">
            We may modify these Terms at any time. If we make material changes, we will post the updated Terms with a
            revised “Last updated” date. Continued use after changes constitutes acceptance.
          </p>

        <h4 className="text-[22px] font-bold text-black mt-6">11. Contact</h4>
        <p className="text-[18px] text-gray-500">
            For questions about these Terms, contact:
          </p>
          <address className="mt-4"> 
            <strong>Town Bell</strong><br />
            Email:{" "}
            <a href="mailto:privacy@townbell.in" className="text-blue-600">
              privacy@townbell.in
            </a>
            <br />
            Website:{" "}
            <a href="https://townbell.in" className="text-blue-600">
              www.townbell.in
            </a>
          </address>

           
        </article>
      </section>
    </main>
  );
};

export default TermsOfService;
